import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import Professional from '../../models/Professional'
import AcademicCourseService from "../../services/AcademicCourseService";
import AcademicCourse from "../../models/AcademicCourse";

export class ReRegistrationCourseFormItem {
    Id: number;
    Institution: string | undefined;
    YearCompletion: number | undefined;
    Course: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;

    constructor(Id: number, Institution?: string, Course?: string, YearCompletion?: number) {
        this.Id = Id;
        this.Institution = Institution;
        this.Course = Course;
        this.YearCompletion = YearCompletion;
    }

    static NewInstance(): ReRegistrationCourseFormItem {
        return new ReRegistrationCourseFormItem(0, "", "");
    }

}

export default class ReRegistrationCourseForm implements FormBase {

    Institution: FormFieldBase;
    YearCompletion: FormFieldBase;
    Course: FormFieldBase;
    FormItemList: ReRegistrationCourseFormItem[];
    FormRemoveList: ReRegistrationCourseFormItem[];
    FormItemToEdit: ReRegistrationCourseFormItem;

    constructor(Institution: string, Course: string, YearCompletion: string) {

        this.Institution = new FormFieldBase(Institution, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.YearCompletion = new FormFieldBase(YearCompletion, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.Course = new FormFieldBase(Course, [], () => "", (value: any) => { this.InputChangeCustom(value) });
        this.FormItemList = new Array<ReRegistrationCourseFormItem>();
        this.FormRemoveList = new Array<ReRegistrationCourseFormItem>();
        this.FormItemToEdit = ReRegistrationCourseFormItem.NewInstance();
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<boolean> {
        if ((this.FormItemList !== null && this.FormItemList.length > 0) || (this.FormRemoveList !== null && this.FormRemoveList.length > 0)) {
            const dataJson = this.getJsonObjet();
            return AcademicCourseService.postInsertOrUpdateAcademic(dataJson, Professional.Id);
        } else {
            return Promise.resolve(true);
        }
    }


    AddOrUpdateReRegistrationCourseFormItem() {

        this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
        this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

        this.Institution.Mandatory = true;
        this.YearCompletion.Mandatory = true;
        this.Course.Mandatory = true;

        if (this.ValidateForm()) {

            //Insert
            if (this.FormItemToEdit === null || this.FormItemToEdit.Id === 0) {

                let item = new ReRegistrationCourseFormItem(
                    this.getNewId(),
                    this.Institution.Value,
                    this.Course.Value,
                    this.YearCompletion.Value
                )

                this.FormItemList.push(item);

            //Update
            } else {
                for (let index = 0; index < this.FormItemList.length; index++) {
                    const element = this.FormItemList[index];
                    if (element.Id === this.FormItemToEdit.Id) {

                        let item = new ReRegistrationCourseFormItem(
                            element.Id,
                            this.Institution.Value,
                            this.Course.Value,
                            this.YearCompletion.Value
                        )

                        item.RemoveTasy = element.RemoveTasy;
                        item.TasyCode = element.TasyCode;

                        this.FormItemList[index] = item;
                    }
                }
            }
            this.ResetForm();
        }
    }

    async PreloadFormFromApi(requestId: string): Promise<any> {

        return await AcademicCourseService.CreateAndGetAcademicCourseFromTasy(requestId).then((data: AcademicCourse[]) => {

            this.FormItemList = new Array<ReRegistrationCourseFormItem>();
            this.FormRemoveList = new Array<ReRegistrationCourseFormItem>();

            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                
                let item = new ReRegistrationCourseFormItem(
                    this.getNewId(),
                    element.InstitutionName,
                    element.CourseName,
                    element.YearCompletion
                )

                item.RemoveTasy = element.RemoveTasy;
                item.TasyCode = element.TasyCode;

                this.FormItemList.push(item);

            }

        });
    }

    EditReRegistrationCourseFormItem(id: number) {
        this.ResetForm();

        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];

            if (element.Id === id) {
                this.FormItemToEdit = element;
                this.Institution.Value = this.FormItemToEdit.Institution;
                this.Course.Value = this.FormItemToEdit.Course;
                this.YearCompletion.Value = this.FormItemToEdit.YearCompletion;
            }
        }
    }

    RemoveReRegistrationCourseFormItem(id: number) {
        for (let index = 0; index < this.FormItemList.length; index++) {
            const element = this.FormItemList[index];
            if (element.Id === id) {
                if(element.TasyCode === undefined || element.TasyCode === 0) {
                    this.FormItemList.splice(index, 1);
                }else{
                    element.RemoveTasy = true;
                    this.FormRemoveList.push(element);
                    this.FormItemList.splice(index, 1);
                }
            }
        }
    }

    ValidateToGoNextStep(): string {
        return "";
    }

    InputChangeCustom(Value: any): void {

        if (Value != null && Value !== "") {

            this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
            this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

            this.Institution.Mandatory = true;
            this.YearCompletion.Mandatory = true;
            this.Course.Mandatory = true;

        } else {

            let propNames = Object.getOwnPropertyNames(this);

            let existFieldImputed = false;

            for (let index = 0; index < propNames.length; index++) {
                const element = propNames[index];
                const value = this.GetFieldByName(element).Value;

                if (value != null && value !== "" && value.toString().trim() !== "") {
                    existFieldImputed = true;
                }
            }

            if (existFieldImputed) {
                this.Institution.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.YearCompletion.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];
                this.Course.Validations = [new ValidationBase("", ValidationType.OBRIGATORIO)];

                this.Institution.Mandatory = true;
                this.YearCompletion.Mandatory = true;
                this.Course.Mandatory = true;
            } else {
                this.Institution.Validations = [];
                this.YearCompletion.Validations = [];
                this.Course.Validations = [];
                this.Institution.Error = "";
                this.YearCompletion.Error = "";
                this.Course.Error = "";
                this.Institution.Mandatory = false;
                this.YearCompletion.Mandatory = false;
                this.Course.Mandatory = false;
            }
        }
    }

    static NewInstance(): ReRegistrationCourseForm {
        return new ReRegistrationCourseForm("", "", "");
    }

    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }

    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.FormItemToEdit = ReRegistrationCourseFormItem.NewInstance();
    }

    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Institution":
                return this.Institution
            case "YearCompletion":
                return this.YearCompletion
            case "Course":
                return this.Course

            default:
                return new FormFieldBase("", []);
        }
    }


    getNewId(): number {
        if (this.FormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.FormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }

    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        if (this.FormItemList != null && this.FormItemList.length > 0) {
            this.FormItemList.forEach((element: ReRegistrationCourseFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "institutionName": element.Institution,
                    "courseName": element.Course,
                    "yearCompletion": (element.YearCompletion !== undefined ? parseInt(element.YearCompletion.toString()) : undefined),
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        if (this.FormRemoveList !== null && this.FormRemoveList.length > 0) {
            this.FormRemoveList.forEach((element: ReRegistrationCourseFormItem) => {
                viewModelList.push({
                    "professionalId": professionalId,
                    "institutionName": element.Institution,
                    "courseName": element.Course,
                    "yearCompletion": (element.YearCompletion !== undefined ? parseInt(element.YearCompletion.toString()) : undefined),
                    "tasyCode": element.TasyCode,
                    "removeTasy": element.RemoveTasy,
                })
            });
        }

        return viewModelList;
    }
}